import React, { Component } from "react";

import { Tooltip } from "@material-ui/core";

import closeIcon from "./../assets/close-icon.png";
import { Drag } from "mdi-material-ui";

import Draggable, { DraggableCore } from "react-draggable";

class Header extends Component {
  render() {
    return (
      <div className={`sc-header dragBtn`}>
        {/*<div className="dragBtn cursor">*/}
        <Tooltip title="Drag chat anywhere on screen" placement="top">
          <Drag className="dragBtnSvg" />
        </Tooltip>
        {/*<img className="sc-header--img" src={this.props.imageUrl} alt="" />*/}
        <div className="sc-header--team-name"> {this.props.teamName} </div>
        <div className="sc-header--bot-state"> {this.props.listeningState} </div>
        <div className="sc-header--close-button-container">
          <div className="sc-header--close-button" onClick={this.props.onClose}>
            <img src={closeIcon} alt="" />
          </div>
        </div>
        {/*</div>*/}
      </div>
    );
  }
}

export default Header;
